export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 3a3 3 0 013 3v3h2.5a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5H4a3 3 0 01-3-3V6a3 3 0 013-3h12zM4 5a1 1 0 00-1 1v12a1 1 0 001 1h3v-8.5A1.5 1.5 0 018.5 9H17V6a1 1 0 00-1-1H4zm6.25 7a.25.25 0 00-.25.25v1.5c0 .138.112.25.25.25h2.5a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25h-2.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};